<template>
  <div class="contentHome">
    <div class="centerPage">
      <div class="login">
        <div class="leftBG">
          <strong>欢迎使用</strong>
          <h1>心理亦笙</h1>
          <div class="content">
            <span>① 输入真实姓名</span>
            <span>② 输入手机号码/邮箱</span>
            <span>③ 输入验证码</span>
            <span>④ 获取手机或邮箱验证码</span>
            <span>⑤ 阅读并同意《用户注册协议》</span>
            <span>⑥ 设置登录密码</span>
          </div>
          <strong>注册完成！</strong>
        </div>
        <el-form ref="userForm" class=" registForm" :model="user">
          <h2 class="title">用户注册</h2>
          <div v-if="show">
            <div class="elInput">
              <el-input v-model="user.name" placeholder="真实姓名"></el-input>
            </div>
            <div class="elInput">
              <el-select style="display: block"
                  v-model="user.from"
                  value-key="id"
                  filterable
                  remote
                  placeholder="请输入推荐医生"
                  no-data-text="无匹配数据"
                  :remote-method="remoteMethod"
                  @clear="clear"
                  clearable
              >
                <el-option
                    v-for="item in regionDataList"
                    :key="item.id"
                    :label="item.fullName?item.fullName:item.enName"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="flex elInput">
              <el-radio-group v-model="registerType">
                <el-radio label="sms">手机号码</el-radio>
                <el-radio label="email">邮箱</el-radio>
              </el-radio-group>
            </div>
            <div class="flex elInput" v-if="registerType=='sms'">
              <el-input type="tel" v-model="user.mobile" placeholder="手机号"></el-input>
            </div>
            <div class="flex elInput" v-if="registerType=='email'">
              <el-input v-model="user.email" placeholder="邮箱"></el-input>
            </div>
            <div class="flex elInput" v-show="captchaShow">
              <el-input type="text" autocomplete='new-password' v-model="user.code" placeholder="验证码"></el-input>
              <div class="flex getCode" @click="reloadCode('vcode')" style="cursor: pointer;">
                <img id="vcode" src="" alt="">
              </div>
            </div>

            <!-- form 表单管理框 -->
            <div class="flex elInput" style="position: relative" v-if="registerType=='sms'">
              <el-input type="text" autocomplete='new-password' v-if="registerType=='sms'" v-model="user.smsCode"
                        placeholder="短信验证码"></el-input>
              <!--              <el-input type="text" autocomplete='new-password' v-model="user.emailCode" placeholder="邮件验证码"></el-input>-->
              <span class="getSmsBtn" v-if="waitSecond <= 0" @click="getVerifyCode">{{ btnText }}</span>
              <span class="getSmsBtn" v-if="waitSecond > 0">{{ waitSecond }}s 后重新获取</span>
            </div>
          </div>

          <div v-show="!show">
            <div style="margin: 0 0 10px 20px;">设置新密码</div>
            <div class="elInput">
              <el-input type="password" v-model="user.password" placeholder="设置密码"></el-input>
            </div>
            <div class="elInput">
              <el-input type="password" autocomplete='new-password' v-model="user.pwd" placeholder="确认密码"></el-input>
            </div>
          </div>

          <div style="width: 90%; margin: 0 auto 10px;">
            <el-checkbox v-model="isAgree">我已阅读并同意<a class="agreement" target="_blank"
                                                     href="/agreement/user">《用户注册协议》</a>
            </el-checkbox>
          </div>

          <div class="elInput" v-show="show">
            <el-button v-if="registerType=='sms'" type="primary" @click="nextForSms()">下一步</el-button>
            <!--<el-button v-if="registerType=='email'" type="primary" @click="nextForEmail()">下一步</el-button>-->
            <el-button v-if="registerType=='email'" type="primary" @click="SendEmailVerification()">发送激活邮件</el-button>
          </div>

          <div class="elInput flex" v-show="!show">
            <el-button type="primary" @click="prev">上一步</el-button>
            <el-button type="primary" @click="register()">注册</el-button>
          </div>

          <div class="elInput flex select" style="justify-content: space-between">
            <a href="javascript:;" @click="$refs.commonRes.registrationMethod=true">医生注册</a>
            <router-link to="/login">返回登录>></router-link>
          </div>
        </el-form>
      </div>

    </div>
    <commonRes ref="commonRes"></commonRes>
    <!--    选择身份-->
    <el-dialog class="registrationMethod" :close-on-click-modal="false" :close-on-press-escape="false"
               :visible.sync="ask" title="选择您的身份" center
               top="0"
               width="500px">
      <div>
        <img src="../assets/img/ask_a.png" alt="">
        <el-button @click="ask=false">普通用户注册</el-button>
      </div>
      <div>
        <img src="../assets/img/ask_b.png" alt="">
        <el-button @click="$refs.commonRes.registrationMethod=true">医生注册</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import SysCons from '@/api/common';
import {Loading} from 'element-ui';
import qs from 'qs';
import commonRes from './famousDoctor/commonRes'
import commonjs from "@/api/common";
import base from "@/api/common";

export default {
  name: "registered",
  data() {
    return {
      data: '',
      isAgree: false,
      registerType: 'sms',
      user: {
        name: '',
        mobile: '',
        smsCode: '',
        from: '',
        email: '',
        emailCode: '',
        password: '',
        pwd: '',
        code: '',
      },
      allDoctor: {
        current: 1,
        size: 10,
        finish: false,
      },
      region_DataList: [],
      regionDataList: [],
      show: true,
      loading: false,

      captchaShow: false,
      btnText: "点击获取",
      waitSecond: -1,
      ask: true,

      userID: '',
      doctorBaseInfoList: [],
    }
  },
  mounted() {
    this.userID = this.$route.params.user
    //console.log(this.userID)
    if (this.userID === "3") {
      this.ask = false
    } else if (this.userID === "2") {
      this.ask = false;
      this.$refs.commonRes.registrationMethod = true
    }
    // 加载医生列表
    // params地址栏拼接：  page: 页码  size: 页数  name: 搜索关键字
    this.$ajax.post(commonjs.basePath + 'auth/auth-doctor/page/base-info?size=40').then(res => {
      if (res.data.status === 'success') {
        let len = res.data.rows.length
        for (let i = 0; i < len; i++) {
          this.doctorBaseInfoList.push({
            value: res.data.rows[i].fullName ? res.data.rows[i].fullName : res.data.rows[i].enName,
            id: res.data.rows[i].id
          })
        }
      }
    });
  },
  methods: {
    getArrs() {
      if (this.allDoctor.finish) {
        return;
      }
      let data = {
        name: this.user.from,
        current: this.allDoctor.current,
        size: this.allDoctor.size,
      };
      // this.$ajax.post(base.basePath + 'auth/auth-doctor/page/base-info?page=' + this.allDoctor.current + '&&size=' + this.allDoctor.size).then(res => {
      this.$ajax.post(base.api.famousDoctor.conditionPage, data).then(res => {
        if (res.data.status === 'success') {
          if (this.region_DataList.length > 0 && res.data.current === 1) {
            return;
          }
          let totalPage = Math.ceil(res.data.total / res.data.size);
          if (res.data.current >= totalPage) {
            this.allDoctor.finish = true;
          } else {
            this.allDoctor.finish = false;
            this.allDoctor.current++;
          }
          this.region_DataList.push(...res.data.rows);
        }
      })
    },
    remoteMethod(query) {
      let vm = this;
      if (query.length >= 2) {
        this.user.from = query
        this.allDoctor.current = 1;
        this.region_DataList.length = 0
        this.allDoctor.finish = false;
        this.getArrs()
        vm.regionDataList = vm.region_DataList
      } else {
        vm.regionDataList = []
      }
    },
    clear() {
      this.allDoctor.current = 1;
      this.region_DataList.length = 0;
      this.allDoctor.finish = false;
      this.getArrs()
      this.regionDataList = []
    },

    /*querySearch(queryString, cb) {
      let restaurants = this.doctorBaseInfoList;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },*/
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    // 下一步
    getVerifyCode() { // 获取  短信/邮件 验证码
      if (this.waitSecond > 0) {
        return;
      }
      let url;
      if (this.registerType == 'sms') {
        if (!SysCons.reg.mobile.test(this.user.mobile)) {
          this.$message.warning('请输入正确的手机号码');
          return;
        }
        url = SysCons.api.sms.register;
      } else if (this.registerType == 'email') {
        if (!SysCons.reg.email.test(this.user.email)) {
          this.$message.warning('请输入正确的邮箱账号');
          return;
        }
        url = SysCons.api.email.register
      } else {
        return;
      }
      this.captchaShow = true;
      if ($.trim(this.user.code).length === 0) {
        this.$message.warning('请输入图形验证码');
        this.reloadCode('vcode');
        return;
      } else if ($.trim(this.user.code).length !== 4) {
        this.$message.warning('图形验证码不正确');
        this.reloadCode('vcode');
        return;
      }
      this.waitSecond = 60;
      let timer = setInterval(() => {
        this.waitSecond--;
        if (this.waitSecond < 0) {
          clearInterval(timer);
        }
      }, 1000);


      let key = $('img#vcode').attr("key") || '';
      this.$ajax.post(url, qs.stringify({
        token: key,
        code: this.user.code,
        mobile: this.user.mobile,
        email: this.user.email
      })).then((res) => {
        if (res.data.status === 'success') {
          this.$message.success("发送成功");
          this.captchaShow = false;
          this.user.code = '';
        } else {
          this.$message.error(res.data.message);
        }
      });

    },
    // 发送邮箱
    SendEmailVerification() {
      let that = this;
      this.captchaShow = true;
      if ($.trim(that.user.code).length === 0) {
        that.$message.warning('请输入图形验证码');
        that.reloadCode('vcode');
        return;
      } else if ($.trim(that.user.code).length !== 4) {
        that.$message.warning('图形验证码不正确');
        that.reloadCode('vcode');
        return;
      }

      if (!that.isAgree) {
        that.$message.error("请先阅读用户注册协议");
        return;
      }

      let key = $('img#vcode').attr("key") || '';
      let data = {
        token: key,
        code: that.user.code,
        email: that.user.email,
        fullName: that.user.name
      };
      that.$ajax.post(SysCons.basePath + 'ysh/user/register/email-active', qs.stringify(data)).then(res => {
        if (res.data.status === 'success') {
          that.$messageBox.alert('邮件发送成功，7日内有效，请尽快前往邮件完成激活！', '提示', {type: 'success'});
        } else {
          that.$message.error(res.data.message);
          that.reloadCode('vcode');
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('发送失败');
      });
    },
    nextForSms() {
      let vm = this;
      if ($.trim(vm.user.name).length === 0) {
        this.$message.info('请输入真实姓名');
        return;
      } else if ($.trim(vm.user.name).length > 30) {
        this.$message.info('姓名不能超过30个字符');
        return;
      }

      if (!SysCons.reg.mobile.test(vm.user.mobile)) {
        this.$message.info('请输入正确的手机号码');
        return;
      }
      if ($.trim(vm.user.smsCode).length === 0) {
        this.$message.info('请输入短信验证码');
        return;
      } else if ($.trim(vm.user.smsCode).length !== 6) {
        this.$message.info('短信验证码不正确');
        return;
      }

      // 校验是否被注册过，没有才到下一步
      let params = {
        "mobile": vm.user.mobile,
        "smsCode": vm.user.smsCode
      };
      vm.$ajax.post(SysCons.api.checkMobile + '?' + $.param(params))
          .then((res) => {
            if (res.data.status == 'success') {
              vm.show = false;
            } else {
              vm.$message.error(res.data.message)
            }
          })
    },
    nextForEmail() {
      let vm = this;
      if ($.trim(vm.user.name).length === 0) {
        this.$message.info('请输入真实姓名');
        return;
      } else if ($.trim(vm.user.name).length > 30) {
        this.$message.info('姓名不能超过30个字符');
        return;
      }

      if (!SysCons.reg.email.test(vm.user.email)) {
        this.$message.info('请输入正确的邮箱');
        return;
      }
      if ($.trim(vm.user.emailCode).length === 0) {
        this.$message.info('请输入邮箱验证码');
        return;
      } else if ($.trim(vm.user.emailCode).length !== 6) {
        this.$message.info('邮箱验证码不正确');
        return;
      }
      let params = {
        "email": vm.user.email,
        "emailCode": vm.user.emailCode
      };
      vm.$ajax.post(SysCons.api.checkEmail + '?' + $.param(params))
          .then((res) => {
            if (res.data.status == 'success') {
              vm.show = false;
            } else {
              vm.$message.error(res.data.message)
            }
          })
    },
    prev() {
      // 返回上一步界面
      this.show = true;
      // 验证码重置
      this.reloadCode('vcode');
    },
    register() {
      let vm = this;
      if (vm.user.password != vm.user.pwd) {
        vm.$message.error("两次密码输入不一致");
        return;
      }
      if (!SysCons.reg.pass.test(vm.user.password)) {
        vm.$message.error("密码不符合规范，长度在6~18之间，只能包含字母、数字");
        return;
      }
      if (!vm.isAgree) {
        vm.$message.error("请先阅读用户注册协议");
        return;
      }
      let url, params;
      if (vm.registerType == 'sms') {
        url = SysCons.api.register.replace('{type}', 'sms');
        params = {
          "code": vm.user.smsCode,
          "mobile": vm.user.mobile,
          "fullName": vm.user.name,
          "password": vm.user.password
        };
      } else if (vm.registerType == 'email') {
        url = SysCons.api.register.replace('{type}', 'email');
        params = {
          "code": vm.user.emailCode,
          "email": vm.user.email,
          "fullName": vm.user.name,
          "password": vm.user.password
        }
      } else {
        vm.$message.error('error');
        return;
      }

      vm.loading = Loading.service({target: '.registForm'});
      vm.$ajax.post(url, qs.stringify(params))
          .then((res) => {
            if (res.data.status == 'success') {
              vm.$message({
                type: 'success',
                message: "注册成功",
                onClose: () => {
                  vm.loading.close();
                  vm.$router.push('/login')
                }
              })
            } else {
              vm.$message.error(res.data.message);
              vm.loading.close();
            }
          })
    },
    reloadCode(id) {
      this.$ajax.post(SysCons.api.captcha).then((res) => {
        if (res.data.status === 'success') {
          $("img#" + id).attr("src", res.data.data);
          $("img#" + id).attr("key", res.data.token);
        }
      });
    }
  },
  beforeMount() {
    // this.reloadCode('vcode')
  },
  components: {
    commonRes
  }
}
</script>

<style scoped lang="scss">
@import '../assets/css/login.scss';

.login .select {
  justify-content: center;
}

.getSmsBtn {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-block;
  width: 120px;
  text-align: center;
  box-sizing: border-box;
  font-size: 13px;
  font-weight: 400;
  color: #FC7B66;
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.agreement {
  text-decoration: underline;
  color: #84a9f3;
  font-size: 12px;
}

.login {
  height: auto;
  width: 750px;

  .leftBG {
    padding: 50px 28px;
    width: 268px;
    background: url('~@/assets/img/user_res_bg.png') no-repeat center;
    background-size: contain;
  }

  .elInput {
    margin-bottom: 15px;
  }
}

.contentHome {
  position: relative;

  &:after {
    content: '';
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: block;
    background: rgba(86, 123, 255, 0.15);
    position: absolute;
  }

  .centerPage {
    z-index: 222;
    position: inherit;
  }
}

</style>
